// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  isLocal: false,
  msalConfig: {
      auth: {
          clientId: '39252cfd-a342-49f1-81b1-af1ba6c31cbb',
          redirectUri: 'https://businesshubapp-dev.com'
      }
  },
  apiConfig: {
      scopes: ['https://bhuborganization.onmicrosoft.com/bhub-api/bhub.read', 'https://bhuborganization.onmicrosoft.com/bhub-api/bhub.write'],
      baseUri: 'https://bhub-gateway-bgiaqhot.ue.gateway.dev'
  },
  b2cPolicies: {
      names: {
          signUpSignIn: "B2C_1_signupsignin1",
          resetPassword: "B2C_1_reset_password",
          editProfile: "B2C_1_edit_profile"
      },
      authorities: {
          signUpSignIn: {
            authority: 'https://bhuborganization.b2clogin.com/bhuborganization.onmicrosoft.com/B2C_1_signupsignin1'
          },
          resetPassword: {
            authority: 'https://bhuborganization.b2clogin.com/bhuborganization.onmicrosoft.com/B2C_1_reset_password'
          },
          editProfile: {
            authority: 'https://bhuborganization.b2clogin.com/bhuborganization.onmicrosoft.com/B2C_1_edit_profile'
          }
      },
      authorityDomain: "bhuborganization.b2clogin.com"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
